import styled from 'styled-components';

export const ReportButton = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  border: 1px solid #e74c3c;
  border-radius: 5px;
  background: white;
  color: #e74c3c;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #e74c3c;
    color: white;
  }
`;

export const ReportModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
`;

export const ModalContent = styled.div`
  position: relative;
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ModalHeader = styled.div`
  padding: 25px 25px 15px 25px;
  border-bottom: 1px solid #eee;

  h3 {
    margin: 0 0 10px 0;
    font-size: 22px;
    color: #333;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #666;
    line-height: 1.5;
  }
`;

export const ModalBody = styled.div`
  padding: 25px;

  label {
    display: block;
    margin-bottom: 12px;
    font-weight: 600;
    color: #333;
    font-size: 14px;
  }
`;

export const ReasonOption = styled.div`
  padding: 15px;
  margin-bottom: 10px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 15px;
  color: #555;

  &:hover {
    border-color: #667eea;
    background: #f8f9ff;
  }

  &.selected {
    border-color: #667eea;
    background: #667eea;
    color: white;
    font-weight: 600;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #667eea;
  }
`;

export const ModalFooter = styled.div`
  padding: 15px 25px 25px 25px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const SubmitButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  background: #e74c3c;
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #c0392b;
    transform: translateY(-2px);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
  }
`;

export const CancelButton = styled.button`
  padding: 12px 24px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
  color: #666;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
    border-color: #999;
  }
`;
